const lang = "fr";
const translations = require("../i18n/fr.js");

const ASSETS_COLOR = {
  'fonds-euro': '#83e9d6',
  'obligations-souveraines': '#f5ba58',
  'obligations-corporate': '#fbde91',
  'actions-us-canada': '#5b6b7c',
  'actions-europe-et-zone-euro': '#95a4b5',
  'actions-japon': '#97c1dd',
  'actions-emergents': '#cadbe7',
  'matieres-premieres': '#f4b7c1',
  'alternatif': '#c086f7',
  'actions-monde': '#97c1dd',
  'uc-total': '#9FDDE4',
  'obligations-taux-fixe': '#95a4b5',
  'obligations-taux-variable': '#97c1dd',
  'obligations-indexees-inflation': '#fbf191',
  'immobilier': '#f4b7c1',
  'liquidites': '#97c1dd',
  'autres': '#cadbe7'
}

const ASSETS_COLOR_SIMULATION = {
  'fonds-euro': '#9FDDE4',
  'obligations': '#FCCE9D',
  'actions': '#C7E5A9',
  'matieres-premieres': '#CEC3EA',
  'alternatif': 'rgba(15, 127, 143, .4)',
}

module.exports = {
  LANG: lang,
  DATE_FORMAT: "MM-DD-YYYY",
  TRANSLATIONS: translations,
  SESSION_EXPIRATION_TIMEOUT: 1200000, // 20min
  AUTO_LOGOUT_TIMEOUT: 180000, // 3min
  ACTION_PING_DELAY: 300000, // 5min
  PASSWORD_MIN_LENGTH: 10,

  COORDINATES: {
    EMAIL: "conseiller@wesave.fr",
    PHONE: "01 80 49 70 00"
  },

  PROJECTION_COLOR: {
    ACCUMULATE_PAYMENTS: '#666',
    OVER_PERFORMANCE: '#e1ef5a',
    EXPECTED_PERFORMANCE: '#a1db5e',
    LOW_PERFORMANCE: '#a8bbad',
    ULTIMATE_GOAL: '#ccdfeb'
  },

  FONT_CHARTS: {
    fontFamily: 'Poppins'
  },

  PIECHART_DONUT: {
    innerSize: '80%'
  },

  HISTORY_CHART: {
    xAxisLabels: {
      style: { fontSize: '1em' }
    },
    plotOptions: {
      dataLabels: {
        formatter: null
      }
    },
    traceZeroLine: {
      optionsLine: {
        color: '#5e8eb8'
      }
    },
    colorSerie: {
      color_1: '#a9bbcb',
      color_2: '#86e1cb',
      color_min: '#e6808d',
      color_max: '#36D693'
    },
    label: {
      color: '#2e3946'
    }
  },

  SIMULATION_CHART: {
    chart: {
      marginRight: 100
    },
    tooltip: {
      borderColor: '#9AB4CB'
    },
    xAxis: {
      lineWidth: 1,
      lineColor: '#9AB4CB',
      tickWidth: 1,
      labels: {
        color: '#606060',
        fontSize: '11px',
        fontWeight: 'normal',
        align: 'center'
      }
    },
    yAxis: {
      lineWidth: 1,
      lineColor: '#9AB4CB',
      labels: {
        color: '#606060',
        fontSize: '11px',
        fontWeight: 'normal'
      }
    },
    plotLine: {
      color: '#5E8EB8'
    },
    plotBand: {
      color: 'rgba(127,201,235,.2)'
    },
    worstCaseCircle: {
      stroke: '#E6808D',
      fill: 'rgba(230,128,141,.3)'
    },
    targetCircle: {
      stroke: '#5E8EB8',
      fill: 'rgba(154,180,203,.4)'
    }
  },

  SIMPLIFIELD_VIEW: {
    profitLineHeight: 257
  },

  ALLOCATION_TAB: {
    color: '#F6F9FA'
  },

  FEATURES: {
    RED_ASTERISK: true,
    BLOG: false,
    GESTION: false,
    IMMO: false,
    SPONSORSHIP: false,
    SIMULATION: {
      DISPLAY_DISCLAIMER: true,
      FASTPASS_TO_SIMULATION: false,
      ALWAYS_DISPLAY_POPIN_ON_ONBOARDING: false,
      POSSIBILITY_TO_HAVE_NO_PROJECT: true,
      ACTIVE_DESCRIPTION: true,
      SHOW_PERCENT_IN_WORLDMAP: true,
      ACTIVE_CONFIRM_SIMULATION: true,
      DISPLAY_RISK: true,
      PROFILE_ANALYSIS: {
        DISPLAY_PORTFOLIO_FULL_RISK_NAME: false, // if false, display the short risk name.
        DISPLAY_WARNINGS: false, // If sent to true, it will required backend modifications to return warnings. And warnings FR trads.
      },
      OPTIONS: {
        PROMOTIONAL_CODE_BUTTON: true,
        DISPLAY_INVESTOR_COMMENT: true,
        GOAL: {
          DEFAULT: 120000,
          MIN: 1000,
          MAX: 1000000,
        },
        YEARS: {
          DEFAULT: 10,
          MIN: 1,
          MAX: 40,
        },
        MONTHLY: {
          DEFAULT: 200,
          MIN: 20,
          MAX: 2000,
        },
        INITIAL_AMOUNT: {
          DEFAULT: 50000,
          MIN: 300,
          MAX: 1000000,
        },
        DEFAULT_RISK_PROFIL: 5,
      },
      OPTIONS_POPIN: {
        DISCLAIMER: true,
      },
      LOSS_RECAP_POPIN: {
        DISPLAY_BAD_INDICATOR: true,
      }
    },
    CONFIRMATION: {
      DISPLAY_PROJECT_RISK_LEVEL: true,
      DISPLAY_OVER_3_CHECKBOX: true,
    },
    CONTRACTS: {
      MANDATORY_SCROLL_PDF: false,
    },
    PROJECTION: {
      SHOW_PERFORMANCE_PERCENTAGE: true,
    },
    SUBSCRIPTION: {
      ACTIVE_BIRTHNAME: true,
      ACTIVE_EMAIL: false,
      DISCLAIMER_INFORMATION: false,
      POPIN: {
        DISPLAY_YEARS_OF_GOAL: true,
      },
      RISK_RECOMMENDED_STRICT: false,
    },
    PROJECTS: {
      DISPLAY_PROJECT_RISK_LEVEL: true,
      IN_VALIDATION: {
        DISPLAY_PARTNER: false,
        DISCLAIMER: false,
      }
    },
    MENU: {
      LINK_HELP: true,
      LINK_LOGOUT: true,
    },
    PROFILE: {
      LEGAL_STATUS: true,
      FORM_ORDER_STEP: { 1: 'identity', 2: 'personal-details', 3: 'financial-situation', 4: 'finance-xp', 5: 'saving-goal' },
      ASK_FOR_LIQUIDITY: false,
      PARCOURS_ESG: false,
      ALL_PREFERRED_THEMES: [
        {
          id: 1,
          icon_slug: "co2",
        },
        {
          id: 2,
          icon_slug: "co2",
        },
        {
          id: 3,
          icon_slug: "co2",
        },
        {
          id: 4,
          icon_slug: "water",
        },
        {
          id: 5,
          icon_slug: "co2",
        },
        {
          id: 6,
          icon_slug: "law",
        },
        {
          id: 7,
          icon_slug: "co2",
        },
        {
          id: 8,
          icon_slug: "equality",
        },
        {
          id: 9,
          icon_slug: "money",
        }
      ]
    },
    PROOFS_DOC: true,
    FORM: {
      CONTRACTUAL_CONDITION: {
        ACTIVE_COMPARE_CONTRACTS: true,
        ACTIVE_SEVERAL_TYPES_CONTRACTS: true
      },
      MANAGEMENT_MANDATE: {
        ABOUT_ARBITRATION_MANDATE: true,
        ALLOCATION_PORTFOLIO_DETAIL: false,
        ACTIVE_SHOW_DETAILS_DONUS: true
      },
      DOCUMENTS_ORDER_STEP: { 1: 'contractual-condition', 2: 'management-mandate', 3: 'deposit-confirmation' },
      PAYMENTS: {
        MONTHLY_DEPOSIT_DATE: true,
        FUND_SOURCE: true,
        SELECT_ACCOUNT: false,
        INVESTMENT_PERIOD: false,
        AMOUNT_TO_REACH: false,
      }
    },
    TOPBAR_PHONE: false,
    OPERATIONS: {
      TRANSFERS: {
        ASK_FOR_ORIGIN: true,
        ASK_FOR_PAYMENT_TYPE: true,
        ASK_FOR_CHOICE: true,
      },
      WITHDRAWAL: {
        ASK_FOR_TAXATION: true,
        ASK_FOR_REASON: true,
        ASK_FOR_CHOICE: true,
        DISPLAY_IBAN: true,
      },
      SCHEDULED: {
        DATE_SELECTION: true,
        PASSWORD_REQUIRED: true,
      }
    },
    PROJECT_EVOLUTION: {
      SHOW_PROJECTS_DROPDOWN: true,
      SHOW_DISTRIBUTION_BY_ASSET_CLASS: true,
      SHOW_BENEFICIARY_CLAUSE: true,
      ACCEPT_PROFILE_UPDATE: true,
      ACTIVE_READING_OF_ASSETS_PDF: true
    },
    FINANCIAL_EXPERIENCE: {
      SHOW_ACCOUNT_TYPES: true
    },
    SIDEBAR_PROJECTS_DETAILS: true,
  },

  URLS: {
    HOME: '/',
    BLOG: 'https://blog.wesave.fr',
    BLOG_FEED: 'https://blog.wesave.fr/feed/',
    DICI: 'https://static.wesave.fr/dici/',
    IMMO: 'https://immo.wesave.fr/app/dashboard',
    SIMULATION_NEXT: '/inscription/nextstep/',
    SIGN_IN: '/connexion',
    ACCOUNT: '/espace-membre',
    TRANSFERS: '/app/operation/versement',

    SIMU_STEPS: [
      '/inscription/simulation/',
      '/inscription/profil/',
      '/inscription/confirmation/',
      '/inscription/documents/',
      '/inscription/contrat/'
    ],
    OPE_STEPS: [
      '/operation/simulation/',
      '/operation/profil/',
      '/operation/confirmation/'
    ],
    AFTER_RISK_UPDATE: '/operation/after_risk_update/',
    AFTER_AMENDMENT_SIGN: '/app',
  },

  COLORS: {
    ASSETS: ASSETS_COLOR,
    ORDER_DONUTS_LEGENDS: ['fonds-euro', 'obligations-souveraines', 'obligations-corporate', 'actions-us-canada', 'actions-europe-et-zone-euro', 'actions-japon', 'actions-emergents', 'matieres-premieres', 'alternatif', 'actions-monde', 'uc-total', 'obligations-taux-fixe', 'obligations-taux-variable', 'obligations-indexees-inflation', 'immobilier', 'liquidites', 'autres'],
    WORLDMAP: {
      COLOR_1: '#36ABDF',
      COLOR_2: '#37C9BD',
      STROKE_WIDTH: '1'
    },
    ALLOCATION: {
      'fonds-euro': { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 0 }, stops : [ [0, ASSETS_COLOR['fonds-euro']], [1, '#36D693'] ] },
      'obligations-souveraines': { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 0 }, stops : [ [0, ASSETS_COLOR['obligations-souveraines']], [1, '#fbb991'] ] },
      'obligations-corporate': { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 0 }, stops : [ [0, ASSETS_COLOR['obligations-corporate']], [1, '#f5ba58'] ] },
      'actions-us-canada': { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 0 }, stops : [ [0, ASSETS_COLOR['actions-us-canada']], [1, '#2e3946'] ] },
      'actions-europe-et-zone-euro': { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 0 }, stops : [ [0, ASSETS_COLOR['actions-europe-et-zone-euro']], [1, '#5c6b7e'] ] },
      'actions-japon': { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 0 }, stops : [ [0, ASSETS_COLOR['actions-japon']], [1, '#5e8eb8'] ] },
      'actions-emergents': { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 0 }, stops : [ [0, ASSETS_COLOR['actions-emergents']], [1, '#9ab4cb'] ] },
      'matieres-premieres': { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 0 }, stops : [ [0, ASSETS_COLOR['matieres-premieres']], [1, '#e6808d'] ] },
      'alternatif': { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 0 }, stops : [ [0, ASSETS_COLOR['alternatif']], [1, '#9055dc'] ] },
      'actions-monde': { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 0 }, stops : [ [0, ASSETS_COLOR['actions-monde']], [1, '#5e8eb8'] ] },
      'uc-total': { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 0 }, stops : [ [0, ASSETS_COLOR['uc-total']], [1, '#5e8eb8'] ] },

      'obligations-taux-fixe': { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 0 }, stops : [ [0, ASSETS_COLOR['obligations-taux-fixe']], [1, '#5c6b7e'] ] },
      'obligations-taux-variable': { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 0 }, stops : [ [0, ASSETS_COLOR['obligations-taux-variable']], [1, '#5e8eb8'] ] },
      'obligations-indexees-inflation': { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 0 }, stops : [ [0, ASSETS_COLOR['obligations-indexees-inflation']], [1, '#f5d358'] ] },
      'immobilier': { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 0 }, stops : [ [0, ASSETS_COLOR['immobilier']], [1, '#e6808d'] ] },
      'liquidites': { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 0 }, stops : [ [0, ASSETS_COLOR['liquidites']], [1, '#5e8eb8'] ] },
      'autres': { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 0 }, stops : [ [0, ASSETS_COLOR['autres']], [1, '#9ab4cb'] ] }
    },
    ASSETS_SIMULATION: ASSETS_COLOR_SIMULATION,
    ORDER_DONUTS_LEGENDS_SIMULATION: ['fonds-euro', 'obligations', 'actions', 'matieres-premieres', 'alternatif'],
    ALLOCATION_SIMULATION: {
      'fonds-euro': { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 0 }, stops : [ [-1, 'rgba(54, 171, 223, .5)'], [2, 'rgba(55, 201, 189, .3)'] ] },
      'obligations': { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 0 }, stops : [ [0, 'rgba(250, 217, 97, .2)'], [1, 'rgba(247, 107, 28, .2)'] ] },
      'actions': { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 0 }, stops : [ [0, 'rgba(180, 236, 81, .2)'], [1, 'rgba(66, 147, 33, .2)'] ] },
      'matieres-premieres': { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 0 }, stops : [ [0, 'rgba(48, 35, 174, .2)'], [1, 'rgba(200, 109, 215, .2)'] ] },
      'alternatif': { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 0 }, stops : [ [0, 'rgba(15, 127, 143, .2)'], [1, 'rgba(15, 127, 143, .2)'] ] },
    },
    COMMON: {
      BLUE        : '#5e8eb8',
      GREEN       : '#36D693',
      DARK_BLUE   : '#2e3946',
      VIKING      : '#58DCAD',
      PINK        : '#E155ED',
      HELIOTROPE  : '#D082FB',
      FUCHSIA     : '#6C44C4'
    },
    RISKS: [
      { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 1 }, stops : [ [0, '#91bee5'], [1, '#5a8cb8'] ] },
      { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 1 }, stops : [ [0, '#91bee5'], [1, '#5a8cb8'] ] },
      { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 1 }, stops : [ [0, '#90e6e2'], [1, '#5ab4b0'] ] },
      { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 1 }, stops : [ [0, '#90e6e2'], [1, '#5ab4b0'] ] },
      { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 1 }, stops : [ [0, '#8ee6c9'], [1, '#a5d578'] ] },
      { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 1 }, stops : [ [0, '#8ee6c9'], [1, '#a5d578'] ] },
      { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 1 }, stops : [ [0, '#b892e6'], [1, '#8259b3'] ] },
      { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 1 }, stops : [ [0, '#b892e6'], [1, '#8259b3'] ] },
      { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 1 }, stops : [ [0, '#d993e6'], [1, '#ac63b9'] ] },
      { linearGradient : { x1: 0, y1: 0, x2: 1, y2: 1 }, stops : [ [0, '#d993e6'], [1, '#ac63b9'] ] }
    ],
    PROFILES: [
      '#7CCEB3',
      '#7CCEB3',
      '#7FB3E0',
      '#7FB3E0',
      '#7FB3E0',
      '#BBA7EB',
      '#BBA7EB',
      '#BBA7EB',
      '#F48AFF',
      '#F48AFF'
    ]
  },

  CONTRACTS_NAMES: {
    'sa_assurance_vie': 'WeSave Patrimoine',
    'sa_capitalisation': 'WeSave Patrimoine Capi'
  },

  // TODO : get from backend
  goals: [
    {id: 0, name: translations.sidebar.goals[0]},
    {id: 1, name: translations.sidebar.goals[1]},
    {id: 2, name: translations.sidebar.goals[2]},
    {id: 3, name: translations.sidebar.goals[3]},
    {id: 4, name: translations.sidebar.goals[4]},
    {id: 5, name: translations.sidebar.goals[5]},
    {id: 6, name: translations.sidebar.goals[6]},
    {id: -1, name: translations.sidebar.goals[-1]}
  ],

  monthly_deposit_date: [
    {id: 0, name: "Le premier du mois"},
    {id: 1, name: "Le 10 du mois"},
    {id: 2, name: "Le 15 du mois"},
    {id: 3, name: "Le 20 du mois"},
    {id: 4, name: "Fin du mois"}
  ],

  fund_source: [
    {id: 12, name: "Héritage / Donation"},
    {id: 13, name: "Vente d'actifs immobiliers"},
    {id: 19, name: "Capitaux activité professionnelle"},
    {id: 21, name: "Cession de bien"},
    {id: 22, name: "Épargne déjà constituée"},
    {id: 23, name: "Gains aux jeux"},
    {id: 24, name: "Indemnisation / Dommages intérêts"}
  ],

  fund_purpose: [
    {id: 7,  name: "Trésorerie / Revenus"},
    {id: 8,  name: "Projets Conso"},
    {id: 9,  name: "Donation / Aide d'un tiers"},
    {id: 10, name: "Investissement / Acquisition"},
    {id: 11, name: "Remboursement de crédit"},
    {id: 12, name: "Transfert vers autre produit"},
    {id: 13, name: "Fin de relation commerciale"}
  ],

  operations_categories: [
    {id: 'all', name: translations.cash_transfer.kind.all },
    {id: 'VLC', name: translations.cash_transfer.kind.VLC },
    {id: 'VEP', name: translations.cash_transfer.kind.VEP },
    {id: 'RAP', name: translations.cash_transfer.kind.RAP },
    {id: 'RPP', name: translations.cash_transfer.kind.RPP },
    {id: 'ARA', name: translations.cash_transfer.kind.ARA },
    {id: 'FRG', name: translations.cash_transfer.kind.FRG },
    {id: 'AVA', name: translations.cash_transfer.kind.AVA },
    {id: 'PAB', name: translations.cash_transfer.kind.PAB },
    {id: 'DDR', name: translations.cash_transfer.kind.DDR }
  ],
  legal_capacity: [
    {id: 10, name: "Capable"},
    {id: 3, name: "Sous tutelle"},
    {id: 13, name: "Sous curatelle"},
    {id: 15, name: "Sous sauvegarde de justice"},
    {id: 1, name: "Mineur sous administration légale pure et simple"}
  ],
  popin_data: {
    identity: {
      title: "Pièce d'identité",
      subtitle: "En cours de validité",
      multi_file: true,
      list_docs: [
        {name: "Carte Nationale d'identité", desc: "Recto et Verso"},
        {name: "Passeport", desc: "Pages 2 et 3"}
      ]
    },
    residency: {
      title: "Justificatif de domicile",
      subtitle: "De moins de 3 mois",
      multi_file: true,
      list_docs: [
        {name: "Facture", desc: "gaz, eau, électricité"},
        {name: "Échéancier", desc: "gaz, eau, électricité"},
        {name: "Avis d'imposition", desc: "Page 1"},
        {name: "Avis de taxe d'habitation", desc: "Page 1"},
        {name: "Quittance de loyer", desc: ""},
        {name: "Attestation d'hébergement", desc: ""},
      ]
    },
    rib: {
      title: "Confirmez les informations de votre RIB",
      subtitle: "Le RIB doit provenir d'un compte courant français à votre nom",
      multi_file: false
    },

  }
};
